import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useAppDispatch } from '@SonarCX/hooks/redux'
import { Activity } from 'iconsax-react'
import { useTheme } from '@mui/material'

import CopyableStateProvider from '@SonarCX/providers/CopyableStateProvider'

import Message from '../../../molecules/Message'
import UserJoinedAlert from '../../Notification/UserJoinedAlert'
import CollapseButton from '../../../atoms/CollapseButton'

import { createViewableSession } from './helper'
import { Routes } from '@SonarCX/Routes'
import { fetchUserTimeline } from '@SonarCX/lib/api'
import { useCustomerContext } from '@SonarCX/providers/CustomerProvider'
import {
  CONVERSATION_FILTERS,
  useSocket
} from '@SonarCX/providers/SocketProvider'
import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import { AddErrorAlert } from '@SonarCX/slices/alert'
import useStyles from './styles'

const RecentActivity = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const theme = useTheme()
  const { id } = useParams()

  const { setCustomerSession } = useCustomerContext()
  const {
    api: { handleFilterChange }
  } = useSocket()
  const { up770 } = useBreakpoint()

  const [msgs, setMsgs] = React.useState([])
  const [session, setSession] = React.useState('')
  const [expanded, setExpanded] = React.useState(true)
  const [disable, setDisable] = React.useState(true)
  const classes = useStyles({ disable })
  const targetRef = React.useRef()

  // grab user ID from url and fetch latest messages
  React.useEffect(() => {
    let mounted = true

    fetchUserTimeline(id, 3)
      .then(data => {
        mounted && setMsgs(data.data.reverse())
      })
      .catch(err => {
        console.error('Error fetching timeline', err)
        dispatch(AddErrorAlert({ err }))
      })

    return () => {
      mounted = false
    }
  }, [id, dispatch])

  // setting session id for go back url
  React.useEffect(() => {
    if (msgs.length) {
      const id = msgs[0].sessionId
      setSession(id)
      setCustomerSession(id)
      setDisable(false)
    }
  }, [msgs, setCustomerSession])

  const timelineToElements = timeline =>
    timeline.map(e => {
      if (e.action === 'join') {
        return (
          <UserJoinedAlert
            key={e.id}
            sender={e.content.user?.name}
            style={{ justifyContent: 'center' }}
            className={classes.start}
            date={e.stamp}
          />
        )
      } else {
        return (
          <CopyableStateProvider key={e.id}>
            <Message
              media={e.content.media}
              content={e.content.body}
              senderFull={e.content.user}
              sender={e.content.user?.name}
              date={e.stamp}
              className={classes.retryMsgs}
              isPrivateNote={e.action_type === 'note'}
              recentActivity
            />
          </CopyableStateProvider>
        )
      }
    })

  const noElements = () => {
    return <div style={{ fontStyle: 'italic' }}> No recent activity </div>
  }

  const goToTimeline = async () => {
    if (session) {
      handleFilterChange(CONVERSATION_FILTERS.OPEN, false)
      history.push(`${Routes.TIMELINE}/?session=${session}`)
    } else {
      // no recent activities on the user
      const newSessionID = await createViewableSession(id)
      history.push(`${Routes.TIMELINE}/?session=${newSessionID}`)
    }
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.title}>
          <div
            style={{
              display: 'flex',
              cursor: 'default',
              alignItems: 'center',
              gap: 9
            }}
          >
            <Activity size={theme.size.base} variant='Bold' color='grey' />{' '}
            ACTIVITY
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className={classes.link} onClick={() => goToTimeline()}>
              {' '}
              GO TO TIMELINE
            </div>
            {up770 && (
              <CollapseButton
                open={expanded}
                onToggle={() => setExpanded(!expanded)}
              />
            )}
          </div>
        </div>
        {expanded && (
          <div className={classes.messages} ref={targetRef}>
            {msgs.length ? timelineToElements(msgs) : noElements()}
          </div>
        )}
      </div>
    </>
  )
}

export default RecentActivity
